import { useTranslation } from 'next-i18next'
import { twMerge } from 'tailwind-merge'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import SioLogoIcon from 'shared/icons/sio-logo-icon'
import {
  PUBLIC_LAYOUT_TOP_PADDING,
  PUBLIC_LAYOUT_X_PADDING,
} from '../constants/public-layout-constants'
import DesktopMenu from './components/desktop-menu'
import MobileMenu from './components/mobile-menu'
import publicHeaderBackground from '/public/images/public-header-background.png'

const PublicHeader = ({ title }: { title: string }) => {
  const { t } = useTranslation()
  return (
    <div
      className={twMerge(
        PUBLIC_LAYOUT_TOP_PADDING,
        PUBLIC_LAYOUT_X_PADDING,
        `flex w-full flex-col items-center gap-16 bg-cover bg-bottom bg-no-repeat pb-20 lg:pb-36 [&>*]:max-w-[1120px]`,
      )}
      style={{ backgroundImage: `url(${publicHeaderBackground.src})` }}
    >
      <div
        className={
          'flex w-full items-center justify-between gap-5 font-mulish text-[18px] text-text-secondary [&>*]:hover:text-text-tertiary'
        }
      >
        <LinkWithoutPrefetch
          href={'/'}
          className={
            'w-fit rounded-md outline-none ring-brand-primary ring-offset-2 focus-visible:ring-2'
          }
        >
          <SioLogoIcon className={'shrink-0 scale-75'} />
        </LinkWithoutPrefetch>
        <DesktopMenu />
        <MobileMenu />
      </div>
      {title && (
        <h1 className={'font-ubuntu text-[35px] leading-normal text-text-primary lg:text-[56px]'}>
          {t(title)}
        </h1>
      )}
    </div>
  )
}

export default PublicHeader
